import { render, staticRenderFns } from "./energy-dedication-modal.vue?vue&type=template&id=51d5f500&"
import script from "./energy-dedication-modal.ts?vue&type=script&lang=js&"
export * from "./energy-dedication-modal.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports